



















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ScoreService } from "@/services/score-service";
import { Prize } from '@/model/prize';
import DatePicker from "vue2-datepicker";
import { signIn, signOut, signedIn, authManager} from '../utils/login';
import * as Constants from '@/utils/constants';

@Component({
    components: {
        DatePicker
    }
})
export default class PrizeDetail extends Vue {
    // data
    error: any = null;
    loading: boolean = false;
    prize: Prize = new Prize();
    dismissSecs: number = 10;
    dismissCountDown: number = 0;
    showDismissibleAlert: boolean = false;
    prizeImage: any = null;
    currentTimeInMillis = new Date().getTime(); // Used to force image reload
    
    // data for login
    token: string = "";

    prizeService: ScoreService = new ScoreService();

    // computed
    get isValidForm () {
        return this.prize.title && this.prize.description && this.prize.value && this.prize.ordBy;
    }

    get prizeImageName(): string {
        if (this.prizeImage && this.prizeImage.name) {
            return this.prizeImage.name;
        } else {
            return "nessuna";
        }
    }

    get newTimeInMillis(): number {
        return new Date().getTime();
    }

    @Prop()
    user: any;

    // methods
    created() {
        this.token = this.user.access_token;
        this.updatePrize();
    }

    get isSignedIn() {
      return this.user !== null;
    }

    get isAdmin() {
      return this.user.profile.roles.indexOf(Constants.ADMIN_ROLE) > -1;
    }

    updatePrize() {
        this.prizeService.getPrize(this.$route.params.id, this.token).then((prize: Prize) => {
            this.prize = prize;              
        })
    }

    savePrize() {
        if (!this.isValidForm) {
            alert("Devi inserie un titolo, una descrizione e un valore.");
            console.log("Form non valido.");
            return;
        }

        this.prizeService.updatePrize(this.prize, this.prize.id, this.token)
        .then((responseStatusCode) => {    
            if(responseStatusCode === 200) {
                this.showDismissibleAlert = true;
                this.toPrizeList();
            } else {
                console.log("Errore!")
                alert("Errore nel salvataggio delle modifiche.");
                this.showDismissibleAlert = false;
            }
        })
    }

    countDownChanged(dismissCountDown: number) {
      this.dismissCountDown = dismissCountDown
    }

    showAlert() {
      this.dismissCountDown = this.dismissSecs
    }

    toPrizeList() {
        this.$router.push({ name: "prizesList", params: { updated: "ok" } });
    }

    updatePrizeImage() {
        if (this.prizeImage) {
            this.prizeService.uploadPrizeImage(this.prize.id, this.prizeImage, this.token)
            .then((response) => {
                if (response.status === 200) {
                    console.log("Prize image uploaded.");
                    this.updatePrize();
                    this.currentTimeInMillis = new Date().getTime();
                } else {
                    console.log("Response status: " + response.status);
                } 
            })
            .catch((e) => {
                alert("Errore in caricamento immagine: " + e.message);
            })
        }
    }
}
